<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    <continent-list-filter
      @edit="editComponentFilters($event, 'filter__continent')"
      @clean="cleanComponentFilters(['filter__continent'])"
    />
    <administrative-area-list-filter
      @edit="editComponentFilters($event, 'filter__admin_area')"
      @clean="cleanComponentFilters(['filter__admin_area'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as COUNTRY_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'CountryCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: COUNTRY_TYPES.GENERIC.l10n.country.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...COUNTRY_TYPES.GENERIC.l10n.country.LIST.ACTIONS
    })
  }
}
</script>
